import { font } from '../../../Players/SortImagesActivity/sortImages.utils';
import { StyledSortImagesExtendedDescription } from './SortImagesExtendedDescription.styled';
import Head from 'next/head';
import QuestionCard from '@/shared/Activities/GameActivity/SortImagesGameActivity/ConceptQuestActivity/QuestionCard/QuestionCard';
import Button from '@/shared/Button/Button';

export default function SortImagesExtendedDescription({ activity, onClose }) {
  const { folder } = activity.data;

  return (
    <>
      <Head>
        <link href={font.url} rel="stylesheet"></link>
      </Head>
      <StyledSortImagesExtendedDescription
        centered
        mask
        width="70%"
        visible
        closable={false}
        footer={<Button onClick={onClose}>Close</Button>}
        title="What is this activity about?"
      >
        <div className="questions">
          {activity.data.questions.map((question) => (
            <QuestionCard
              key={question.id}
              question={question}
              folder={folder}
            />
          ))}
        </div>
      </StyledSortImagesExtendedDescription>
    </>
  );
}
